import { render, staticRenderFns } from "./mail-authorize-modal.vue?vue&type=template&id=0d107782&scoped=true&"
import script from "./mail-authorize-modal.vue?vue&type=script&lang=js&"
export * from "./mail-authorize-modal.vue?vue&type=script&lang=js&"
import style0 from "./mail-authorize-modal.vue?vue&type=style&index=0&id=0d107782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d107782",
  null
  
)

export default component.exports